import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import s from './styles.module.scss'

export interface RoomsInfoMessageProps {
  roomsCount: number
}

export const RoomsInfoMessage: FC<RoomsInfoMessageProps> = ({ roomsCount }) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(s.infoMessage, 'bold-12')}>
      {t('kyrgyzstan_block.select_guests.rooms_booking_info', {
        count: roomsCount,
      })}
    </div>
  )
}
